var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"dd-rotate\" class=\"dd-rotate dropdown-menu hide\">\n    <div class=\"mi\" data-deg=\"90\" title=\"Right\">\n        <span class=\"dd-icon icon-cw-1\"></span>\n        Right\n    </div>\n    <div class=\"mi\" data-deg=\"180\" title=\"Flip\">\n        <span class=\"dd-icon icon-exchange\"></span>\n        Flip\n    </div>\n    <div class=\"mi\" data-deg=\"-90\" title=\"Left\">\n        <span class=\"dd-icon icon-ccw\"></span>\n        Left\n    </div>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/rotate/rotate.hbs
 ** module id = 725
 ** module chunks = 0
 **/